import axios from "axios";
import {_state} from "../state/state.js";

let ajaxUrl;

let instance = null;

export const wpAjaxFunctions = {
    creditApplicationAjax : 'credit_application_ajax',
    employeeApplicationAjax : 'employee_application_ajax',
}

export const ajaxRequest = (queryParams, action) => {
    ajaxUrl = _state.scriptData && _state.scriptData.ajaxUrl ? _state.scriptData.ajaxUrl : null;
    if (ajaxUrl !== null) {
        if(instance === null){
            instance = axios.create({
                baseURL: ajaxUrl,
            });
        }
        queryParams = JSON.stringify(queryParams);
        return instance.post(``, new URLSearchParams({
            action,
            queryParams,
        }));
    } else {
        return null;
    }
}

export const getLocalState = () => {
    const scriptDataLocal = typeof scriptData !== 'undefined' ? scriptData : null;
    return new Promise((resolve, reject) => {
        _state.updateState({scriptData: scriptDataLocal});
        document.querySelector('#antanas_guoga-scripts-main-js-extra')?.remove();
        resolve();
    });
}